<template>
    <nav class="tabs">
        <button @click="menuClick(item)" v-for="item in menus" :key="item" class="tab"
            :class="{ 'active': item.key == selectKey }" data-target="overview">{{ item.name }}</button>
    </nav>
</template>

<script>
export default {
    name: 'TabView',
    props: {
        menus: Array,
        selectKey: {
            type: String,
            default: ""
        }
    },
    methods: {
        ///菜单点击
        menuClick: function (item) {
            this.$emit("menuClick", item)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tabs {
    display: flex;
    gap: 18px;
    border-bottom: 1px solid rgba(148, 163, 184, 0.25);
    margin-bottom: 24px;
}

.tab {
    position: relative;
    padding: 12px 24px;
    font-size: 0.95rem;
    font-weight: 600;
    color: var(--ek-text-color2);
    background: transparent;
    border: none;
    border-bottom: 4px solid transparent;
    transition: var(--transition);
}

.tab.active {
    color: var(--ek-color-primary);
    border-bottom-color: var(--ek-color-primary);
}

.tab:hover {
    color: var(--ek-color-primary);
}

button {
    font-family: inherit;
    cursor: pointer;
}
</style>
